import { Navigate } from "react-router-dom";
import { getStorage } from "../utils/storage";
import Layout from "../components/Layout";

export const ProtectRoutes = ({ children, showHeader }) => {
  const loggedIn = getStorage("user_session");
  if (loggedIn === null) {
    return <Navigate to={"/login"} />;
  }
  return (
    <Layout showHeader={showHeader}>
      {children}
    </Layout>
  );
};
